import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertTriangle, TrendingDown, Target } from 'lucide-react';
export const ProblemAgitate = () => {
  const problems = [{
    icon: <XCircle className="w-6 h-6 text-red-500" data-id="element-171" />,
    title: 'Entrenas duro, pero no se transfiere',
    desc: 'Te matas en el gimnasio levantando pesado, pero el fin de semana te sentís lento, pesado o te ganan en el contacto.'
  }, {
    icon: <TrendingDown className="w-6 h-6 text-red-500" data-id="element-172" />,
    title: 'Estancamiento físico y técnico',
    desc: 'Sentís que llegaste a tu techo. No logras ser más rápido, ni más fuerte, y tus habilidades con la pelota no mejoran.'
  }, {
    icon: <AlertTriangle className="w-6 h-6 text-red-500" data-id="element-173" />,
    title: 'Entrenamiento genérico',
    desc: 'Haces la misma rutina que todos. No sabes cómo adaptar tu preparación física a las exigencias específicas de tu posición.'
  }];
  const positions = ['WINGS Y FULLBACKS', 'CENTROS', 'APERTURAS Y MEDIOSCRUM', 'SEGUNDAS LÍNEAS', 'PILARES Y HOOKERS', 'TERCERAS LÍNEAS'];
  return <section className="w-full py-14 px-4 bg-zinc-900 border-y border-zinc-800" data-id="element-174">
      <div className="max-w-5xl mx-auto" data-id="element-175">
        <div className="text-center mb-10" data-id="element-176">
          <h2 className="text-2xl md:text-4xl font-bold uppercase tracking-tight mb-4 font-oswald text-white" data-id="element-177">
            ¿Te pasa alguna de <span className="text-red-500" data-id="element-178">estas cosas</span>
            ?
          </h2>
          <div className="w-20 h-1 bg-red-500 mx-auto" data-id="element-179"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-5 mb-14" data-id="element-180">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-zinc-950 p-6 rounded-xl border border-zinc-800 hover:border-red-500/50 transition-colors" data-id="element-181">
              <div className="mb-4 bg-red-500/10 w-12 h-12 rounded-full flex items-center justify-center" data-id="element-182">
                {prob.icon}
              </div>
              <h3 className="text-lg font-bold mb-2 font-oswald tracking-wide" data-id="element-183">
                {prob.title}
              </h3>
              <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-184">
                {prob.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="bg-zinc-950 rounded-2xl p-6 md:p-10 border border-lime-500/30 relative overflow-hidden" data-id="element-185">
          <div className="absolute top-0 right-0 w-64 h-64 bg-lime-500/5 blur-[100px] rounded-full" data-id="element-186"></div>

          <div className="text-center mb-6 relative z-10" data-id="element-187">
            <Target className="w-10 h-10 text-lime-400 mx-auto mb-4" data-id="element-188" />
            <h2 className="text-2xl md:text-4xl font-bold uppercase tracking-tight mb-3 font-oswald text-white" data-id="element-189">
              EL RUGBY MODERNO EXIGE{' '}
              <span className="text-lime-400" data-id="element-190">ESPECIFICIDAD</span>
            </h2>
            <p className="text-base md:text-lg text-zinc-300 max-w-3xl mx-auto" data-id="element-191">
              No podés entrenar igual si jugás de pilar que si jugás de wing.
              Necesitás un sistema que entienda las demandas de tu puesto.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-2 relative z-10" data-id="element-192">
            {positions.map((pos, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.08
          }} className="bg-zinc-900 border border-zinc-700 px-4 py-1.5 rounded-full text-lime-400 font-bold tracking-wider text-xs md:text-sm shadow-[0_0_15px_rgba(132,204,22,0.1)]" data-id="element-193">
                {pos}
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};